import type { CommandPromptItem } from "@/components/aios-command/chat/command-prompts";
import type { ExtendedChatMessage } from "@/components/aios-command/chat/chat-types";
import type { ChatMessage } from "@/hooks/use-command-messages";
import type { CommandProject, CommandSession } from "@/types/command-agent";
import type {
    CommandV2PresetCategory,
    CommandV2PresetDisplay,
    CommandV2SidebarProject,
    CommandV2SidebarSession,
    CommandV2ThreadMessage,
} from "@/components/command-team-v2/types";
import { mapMessageToProto } from "@/components/command-team-v2/utils/map-api-to-proto";

export function mapParentCategoryToV2(category?: string | null): CommandV2PresetCategory {
    const upper = (category ?? "").toUpperCase();
    if (upper.includes("EXEC") || upper === "SEE") return "executive";
    if (upper.includes("MANAG") || upper === "DO") return "management";
    return "custom";
}

export function mapPresetToV2Display(
    preset: CommandPromptItem,
    options?: { favourite?: boolean; order?: number }
): CommandV2PresetDisplay {
    return {
        id: preset.id,
        title: preset.title,
        description: preset.description,
        promptText: preset.prompt,
        category: mapParentCategoryToV2(preset.parent_category),
        favourite: options?.favourite ?? false,
        order: options?.order ?? 0,
    };
}

export function mapSessionToV2Sidebar(session: CommandSession): CommandV2SidebarSession {
    const createdAt = session.created_at ?? new Date().toISOString();
    return {
        id: session.id,
        title: session.title?.trim() || "Untitled chat",
        projectId: session.project_id ?? null,
        agentId: session.agent_id ?? null,
        updatedAt: session.updated_at ?? createdAt,
    };
}

export function mapProjectToV2Sidebar(project: CommandProject): CommandV2SidebarProject {
    return {
        id: project.id,
        name: project.name,
    };
}

export function mapChatMessageToV2Thread(
    message: ChatMessage | ExtendedChatMessage
): CommandV2ThreadMessage {
    const mapped = mapMessageToProto(message);
    return {
        id: mapped.id,
        role: mapped.role,
        content: mapped.content,
        pending: mapped.pending,
        suggestions: mapped.suggestions,
        attachedFiles: mapped.attachedFiles,
        streamError: mapped.streamError,
        contentSegments: mapped.contentSegments,
        tools: mapped.tools,
    };
}
